module.exports = __webpack_public_path__ + "img/borussia-dortmund.116622ee.png";